// src/constants/routes.ts
const ROUTE_PREFIX = process.env.REACT_APP_ROUTE_PREFIX || "";

// Define all the routes with the prefix included
export const ROUTES = {
	HOME: `${ROUTE_PREFIX}/`,
	HERO: `${ROUTE_PREFIX}/hero`,
	ACHIEVEMENTS_TEXT: `${ROUTE_PREFIX}/achievements-text`,
	ACHIEVEMENTS_CARDS: `${ROUTE_PREFIX}/achievements-cards`,
	MEDIA_TEXT: `${ROUTE_PREFIX}/media-text`,
	VIDEO_UPLOAD: `${ROUTE_PREFIX}/video-upload`,
	CONTENT_HOW_WE_WORK: `${ROUTE_PREFIX}/content-how-we-work`,
	CONTENT_OUR_MISSION: `${ROUTE_PREFIX}/content-our-mission`,
	PARTNERS_TEXT: `${ROUTE_PREFIX}/partners-text`,
	MANAGE_PARTNERS: `${ROUTE_PREFIX}/manage-partners`,
	FAQ: `${ROUTE_PREFIX}/faq`,
	FOOTER_CONTACTS: `${ROUTE_PREFIX}/footer-contacts`,
	FOOTER_SOCIAL_LINKS: `${ROUTE_PREFIX}/footer-social-links`,
	LOGIN: `${ROUTE_PREFIX}/login`,
	COMPANIES: `${ROUTE_PREFIX}/company`,
	CARGO_OFFERS: `${ROUTE_PREFIX}/offers/cargo`,
	TRANSPORT_OFFERS: `${ROUTE_PREFIX}/offers/transport`,
	MANAGE_OFFERS: `${ROUTE_PREFIX}/offers/manage`,
	VEHICLE_TYPES: "/vehicle-types",
	VEHICLE_BRANDS: "/vehicle-brands",
	VEHICLE_MODELS: "/vehicle-models",
	NEWS: "/news",

	DASHBOARD: `${ROUTE_PREFIX}/dashboard`,

	// Users
	TOTAL_USERS: `${ROUTE_PREFIX}/dashboard/users`,
	SENDERS: `${ROUTE_PREFIX}/dashboard/users/senders`,
	CARRIERS: `${ROUTE_PREFIX}/dashboard/users/carriers`,
	USERS_NEW: `${ROUTE_PREFIX}/dashboard/users/new`, // ?role=sender|carrier&ids=...

	// Offers (single list; ids in query for filters)
	OFFERS_ALL: `${ROUTE_PREFIX}/dashboard/offers/all`,

	// Misc
	COMPLAINTS: `${ROUTE_PREFIX}/dashboard/complaints`,
	POPULAR_ROUTES: `${ROUTE_PREFIX}/dashboard/popular-routes`,
	ACTIVITY_LOG: `${ROUTE_PREFIX}/dashboard/activity-log`,
	ADMIN_USERS: `${ROUTE_PREFIX}/dashboard/admin-users`,
} as const;

// Export all route paths as an array for easy access if needed
export const ROUTE_PATHS = Object.values(ROUTES);
